import { atom } from 'jotai';


const selectionsAtom = atom([]);

export { selectionsAtom };